module.exports = __webpack_public_path__ + "static/img/btn3.a1555e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/btn3.png
// module id = Pki7
// module chunks = 1